import { Card, Grid, Icon } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { deleteDashboardUser, getFillTimeStats, getNotebookStats } from "api/routes";
import { getDashboardUsers } from "api/routes";
import Loading from "components/Loading";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useModal from "../../hooks/useModal";
import NewUserModal from "./NewUserModal";
import UpdateUserModal from "./UpdateUserModal";

export default function UserAccess() {
  const [loading, setLoading] = useState(false);
  const [dashboardUsers, setDashboardUsers] = useState([]);
  const [trigger, setTrigger] = useState(null);
  const [modals, updateModal, closeModal] = useModal({ newUser: { state: false }, updateUser: { state: false } });
  const [notebookStats, setNotebookStats] = useState([]);
  const [fillTimeStats, setFillTimeStats] = useState([]);

  useEffect(() => {
    setLoading(true);
    getDashboardUsers((isOk, data) => {
      if (!isOk) {
        setLoading(false);
        return toast.error(data.message);
      } else {
        setLoading(false);
        setDashboardUsers(data);
      }
    }, trigger !== null);
  }, [trigger]);
  useEffect(() => {
    getNotebookStats((isOk, data) => {
      if (!isOk) {
        return toast.error(data.message);
      } else {
        setNotebookStats(data);
      }
    });
    getFillTimeStats((isOk, data) => {
      if (!isOk) {
        return toast.error(data.message);
      } else {
        setFillTimeStats(data);
      }
    });
  }, []);

  const columns = [
    { field: "index", headerName: "ردیف", width: 70 },
    { field: "username", headerName: "نام کاربری", width: 200 },
    {
      field: "fullname",
      headerName: "نام",
      width: 200,
    },
    {
      field: "role",
      headerName: "دسترسی",
      width: 200,
      renderCell: (params) =>
        <p>{manageRole(params.row.role)}</p>,
    },
    {
      field: "notebook",
      headerName: "تغیرات دفتر",
      width: 120,
      renderCell: (params) =>
        <p>{notebookStats.find(item => item.adminUsername === params.row.username)?.count ?? 0}</p>,
    },
    {
      field: "fillTime",
      headerName: "تغیرات پرکردن تایم",
      width: 150,
      renderCell: (params) =>
        <p>{fillTimeStats.find(item => item.adminUsername === params.row.username)?.count ?? 0}</p>,
    },
    {
      field: "operation",
      headerName: "عملیات",
      width: 60,
      renderCell: (params) =>
        <section style={{ display: "flex", flexDirection: "row", cursor: "pointer" }}>
          {params.row.role !== "center" && <Icon style={{ marginLeft: 2 }} onClick={() => updateModal("updateUser", {
            state: true, data: {
              fullname: params.row.fullname, role: params.row.role, username: params.row.username,
              userId: params.row.dashboardUserId,
            },
          })}
          >edit</Icon>}
          {params.row.role !== "center" && <Icon style={{ color: "red" }} onClick={() => {
            let answer = window.confirm("آیا از حذف کاربر اطمینان دارید؟");
            if (answer) {
              deleteUser(params.row.dashboardUserId);
            } else {
            }
          }}>delete</Icon>}

        </section>,

    },

  ];

  const deleteUser = (userId) => {
    setLoading(true);
    deleteDashboardUser(userId, (isOk, data) => {
      if (!isOk) {
        setLoading(false);
        return toast.error(data.message);
      } else {
        setLoading(false);
        toast.success("کاربر حذف شد");
        setTrigger(Math.random());
      }
    });
  };
  const rows = dashboardUsers.map((item, index) => ({ index: index + 1, ...item, operation: "operation" }));

  function manageRole(role) {
    let text;
    switch (role) {
      case "center":
        text = "ادمین";
        break;

      case "reservation":
        text = "نوبت دهی";
        break;

      case "notebookReservation":
        text = "دفتر نوبت دهی";
        break;

      case "reception":
        text = "پذیرش";
        break;

      default:
        text = "نامعلوم";
        break;
    }
    return text;
  }

  return (
    <DashboardLayout>
      <Loading loading={loading} />
      <MDBox pt={2} mb={6}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg"
                     coloredShadow="info"
                     style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <MDTypography variant="h6" color="white">
                  دسترسی کاربران
                </MDTypography>
                <DashboardNavbar />
              </MDBox>
              <MDBox pt={4} pb={3} px={3}>
                <MDButton onClick={() => updateModal("newUser", { state: true })} variant="gradient" color="info"
                          sx={{ width: "140px", marginRight: 4, marginBottom: 4 }}>
                  اضافه کردن کاربر
                </MDButton>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  pagination={false}
                  getRowId={(item) => item.dashboardUserId}
                  hideFooterPagination
                  hideFooter
                  rowSelection={false}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {modals.newUser.state &&
        <NewUserModal modal={modals.newUser} handleClose={() => closeModal("newUser")} setTrigger={setTrigger} />}
      {modals.updateUser.state &&
        <UpdateUserModal modal={modals.updateUser} handleClose={() => closeModal("updateUser")}
                         setTrigger={setTrigger} />}
    </DashboardLayout>
  );
}
